// extracted by mini-css-extract-plugin
export var smallSpinner = "_qq-0";